var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    {
      'topbar-waring': _vm.topbar.content === 'warning',
      'topbar-info':  _vm.topbar.content === 'info',
      'topbar-offers':  _vm.topbar.content === 'offer'
    } ],attrs:{"id":"topbar"}},[_c('span',[_vm._v(_vm._s(_vm.checkLanguage))]),_c('Close',{attrs:{"color":"#fff"},nativeOn:{"click":function($event){return _vm.setTopbarInactive.apply(null, arguments)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }